/* eslint-disable import/no-unused-modules */
export const DOIS = 2;
export const TRES = 3;
export const QUATRO = 4;
export const CINCO = 5;
export const DEZ = 10;
export const QUATORZE = 14;
export const TRINTA = 30;
export const SESSENTA = 60;
export const CEM = 100;
export const CENTOCINQUENTA = 150;
export const MIL = 1000;

// CNPJ constants
export const TAM_CNPJ = 14;

export const SITE_PLATAFORMA = "https://www.innovei.com.br/";

// ID constants
export const ID_EMPRESA = "1";
export const ID_COLABORADORES = "2";
export const ID_LISTAGEM_IDEIAS_IDEIAS = "3";
export const ID_CADASTROS_QUESTIONARIOS = "5";
export const ID_CADASTROS_GRUPOS_DE_PERGUNTAS = "6";
export const ID_CADASTROS_PERGUNTAS = "7";
export const ID_CADASTROS_TIPO_DE_RESPOSTAS = "8";
export const ID_DESAFIOS_INOVACAO_DESAFIOS = "9";
export const ID_MARCO = "10";
export const ID_CONFIGURACOES_CATEGORIA_DE_INOVACAO = "11";
export const ID_CONFIGURACOES_TIPO_DE_JOGADA = "12";
export const ID_CADASTROS_PROJETOS = "13";
export const ID_DESAFIOS_INOVACAO_REGULAMENTOS = "14";
export const ID_LISTAGEM_IDEIAS_REGULAMENTOS = "15";
export const ID_COMITE_DE_INOVACAO = "16";
export const ID_TODAS_ATIVIDADES = "17";
export const ID_RANKING_COLABORADORES = "18";
export const ID_EXTRAS_IMPLEMENTACAO_DAS_JOGADAS = "19";
export const ID_TIPO_DE_INOVACAO = "20";
export const ID_JOGADAS_DE_INOVACAO = "21";
export const ID_DESAFIOS_INOVACAO_CATEGORIA_DE_DESAFIOS = "22";
export const ID_RELATORIOS_VISAO_GERAL_IDEIAS = "23";
export const ID_RELATORIOS_VISAO_GERAL_DESAFIOS = "24";
export const ID_GERENCIAR_EVIDENCIAS = "25";
export const ID_EXTRAS_VISUALIZAR_NOTAS_DE_AVALIADORES = "26";
export const ID_EXTRAS_DESCONSIDERAR_AVALIACAO = "27";
export const ID_CADASTROS_REGIOES = "28";
export const ID_RESPONDER_QUESTIONARIO = "29";
export const ID_CONVIDAR_COLABORADORES = "30";
export const ID_RELATORIOS_DIAGNOSTICO = "31";
export const ID_EXTRAS_ALTERAR_FASE_DA_EMPRESA = "32";
export const ID_QUESTIONARIO_INOVACAO = "33";
export const ID_RESULTADO_VOTACAO = "34";
export const ID_CADASTROS_EMBAIXADORES = "35";
export const ID_CONFIGURACAO_FORMULARIO_IDEIAS = "36";
export const ID_CONFIGURACOES_PERSONALIZACAO = "37";
export const ID_CONFIGURACAO_CONTAS_EMAIL = "38";
export const ID_CONFIGURACAO_EVENTOS_EMAIL = "39";
export const ID_TRIAGEM_IDEIAS_IA = "40";
export const ID_CONFIGURACAO_TEMPLATES_RELATORIOS = "41";
